import React from "react";

export default function PostChoiceModal({
  isOpen,
  onClose,
  onPostNow,
  onSchedule,
  title = "Post",
  hint
}) {
  if (!isOpen) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog modal-sm">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          {/* <div className="modal-body">
            <p className="mb-0" style={{ color: "#555" }}>
              {hint ?? "What do you want to do?"}
            </p>
          </div> */}
          <div className="modal-footer d-flex justify-content-between">
            <div className="d-flex gap-2">
              <button className="btn btn-primary" onClick={onPostNow}>Post Now</button>
              <button className="btn btn-primary" onClick={onSchedule}>Schedule</button>
            </div>
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}
